import { modals } from '@mantine/modals';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook that provides a function to show a permission denied modal.
 * Use this when a user tries to perform an action they don't have permission for.
 *
 * @param ownerName - Optional name of the asset owner to show in the message
 * @returns showPermissionDeniedModal function
 */
export const usePermissionDeniedModal = (ownerName?: string) => {
  const { t } = useTranslation();

  const showPermissionDeniedModal = useCallback(() => {
    modals.openContextModal({
      modal: 'info',
      title: t('permissions.denied.title', 'Action non autorisée'),
      centered: true,
      innerProps: {
        content: ownerName
          ? t(
              'permissions.denied.contactOwner',
              "Vous n'avez pas les droits pour effectuer cette action. Contactez {{ownerName}} pour obtenir les permissions nécessaires.",
              { ownerName }
            )
          : t(
              'permissions.denied.contactOwnerGeneric',
              "Vous n'avez pas les droits pour effectuer cette action. Contactez le propriétaire du bien pour obtenir les permissions nécessaires."
            ),
        confirmText: t('common.understood', "J'ai compris"),
      },
    });
  }, [ownerName, t]);

  return showPermissionDeniedModal;
};
